/** Sprites SVG de ingredientes (decorativos, aria-hidden). */

const SPRITES = {
  pepperoni: (
    <g>
      <circle cx="20" cy="20" r="16" fill="#B3261E" />
      <circle cx="14" cy="15" r="2.4" fill="#8E1B15" />
      <circle cx="25" cy="23" r="2" fill="#8E1B15" />
      <circle cx="18" cy="27" r="1.6" fill="#8E1B15" />
    </g>
  ),
  basil: (
    <g>
      <path d="M6 30 C 8 12, 26 4, 34 8 C 32 22, 20 34, 6 30 Z" fill="#3F7D3A" />
      <path d="M8 29 C 16 22, 24 15, 32 9" stroke="#2D5E2A" strokeWidth="1.6" fill="none" />
    </g>
  ),
  tomato: (
    <g>
      <circle cx="20" cy="20" r="15" fill="#D9472B" />
      <circle cx="20" cy="20" r="10" fill="#E8644A" />
      <g fill="#F7C9A8">
        <ellipse cx="15" cy="17" rx="2" ry="3" /><ellipse cx="25" cy="17" rx="2" ry="3" /><ellipse cx="20" cy="26" rx="3" ry="2" />
      </g>
    </g>
  ),
  mushroom: (
    <g>
      <path d="M5 20 C 5 9, 35 9, 35 20 Z" fill="#C9A27E" />
      <rect x="15" y="19" width="10" height="14" rx="4" fill="#EBD7C0" />
    </g>
  ),
  jalapeno: (
    <g>
      <circle cx="20" cy="20" r="14" fill="#3F7D3A" />
      <circle cx="20" cy="20" r="8" fill="#9CCB6B" />
      <g fill="#F2F0D0"><circle cx="17" cy="18" r="1.6" /><circle cx="23" cy="21" r="1.6" /></g>
    </g>
  ),
  onion: (
    <g fill="none" stroke="#9B5FA8" strokeWidth="3.2">
      <circle cx="20" cy="20" r="13" /><circle cx="20" cy="20" r="7" stroke="#C59BD0" />
    </g>
  ),
  pepper: <path d="M6 24 C 12 10, 28 10, 34 18 C 28 16, 14 18, 8 28 Z" fill="#2F8F3A" />,
  pineapple: (
    <g>
      <path d="M8 32 L 20 6 L 32 32 Z" fill="#F2C94C" />
      <path d="M8 32 L 32 32" stroke="#E0A92E" strokeWidth="3" />
    </g>
  ),
  ham: <rect x="7" y="9" width="26" height="22" rx="5" fill="#F29C9C" stroke="#E07B7B" strokeWidth="2" />,
  sausage: <ellipse cx="20" cy="20" rx="15" ry="9" fill="#9C5B3B" />,
  bacon: <path d="M4 22 C 12 12, 18 30, 26 18 S 36 16, 36 16 L 36 24 C 30 24, 28 34, 20 28 S 10 26, 4 30 Z" fill="#B5473A" />,
  corn: (
    <g fill="#F2B33D"><circle cx="13" cy="14" r="5" /><circle cx="26" cy="14" r="5" /><circle cx="19" cy="25" r="5" /></g>
  ),
  cheese: <path d="M6 28 L 30 8 L 34 30 Z" fill="#FCD26B" stroke="#E8B54A" strokeWidth="2" />,
  avocado: (
    <g>
      <ellipse cx="20" cy="21" rx="12" ry="15" fill="#5E8F3A" />
      <ellipse cx="20" cy="22" rx="8" ry="11" fill="#C9DE8A" />
      <circle cx="20" cy="25" r="4.5" fill="#7A4B2A" />
    </g>
  ),
  olive: <circle cx="20" cy="20" r="10" fill="none" stroke="#2B2B2B" strokeWidth="6" />,
};

export function spriteForName(name) {
  const n = String(name || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
  if (/peperon|pepperon|salami|chorizo|pastor/.test(n)) return 'pepperoni';
  if (/champi|hongo/.test(n)) return 'mushroom';
  if (/jalap|chile/.test(n)) return 'jalapeno';
  if (/cebolla/.test(n)) return 'onion';
  if (/pimiento/.test(n)) return 'pepper';
  if (/pina|anana/.test(n)) return 'pineapple';
  if (/jamon/.test(n)) return 'ham';
  if (/salchich/.test(n)) return 'sausage';
  if (/tocino|bacon/.test(n)) return 'bacon';
  if (/elote|maiz/.test(n)) return 'corn';
  if (/queso/.test(n)) return 'cheese';
  if (/aguacate/.test(n)) return 'avocado';
  if (/aceitun/.test(n)) return 'olive';
  if (/jitomate|tomate/.test(n)) return 'tomato';
  return 'basil';
}

export function IngredientSprite({ type = 'basil', size = 40, className = '', style }) {
  return (
    <svg
      viewBox="0 0 40 40"
      width={size}
      height={size}
      className={className}
      style={style}
      aria-hidden="true"
      focusable="false"
    >
      {SPRITES[type] || SPRITES.basil}
    </svg>
  );
}

/** Posiciones pseudoaleatorias estables (sobre la pizza) para un ingrediente. */
export function dropPositions(seed, count = 5) {
  let h = 2166136261;
  for (const ch of String(seed)) {
    h ^= ch.charCodeAt(0);
    h = Math.imul(h, 16777619);
  }
  const rand = () => {
    h ^= h << 13;
    h ^= h >>> 17;
    h ^= h << 5;
    return ((h >>> 0) % 1000) / 1000;
  };
  const out = [];
  for (let i = 0; i < count; i++) {
    const ang = rand() * Math.PI * 2;
    const rad = 0.12 + rand() * 0.24; // dentro del queso (radio relativo)
    out.push({
      left: 50 + Math.cos(ang) * rad * 100,
      top: 50 + Math.sin(ang) * rad * 100,
      rot: Math.round(rand() * 360),
      delay: i * 0.05,
    });
  }
  return out;
}
